<rt-dialog-header
  [heading]="'app.requisitions.create_dialog.heading' | translate"
  [subheading]="texts.subheading"
>
  @if (isStep) {
    <span class="step">{{ 'app.requisitions.create_dialog.step_2_of_2' | translate }}</span>
  }
</rt-dialog-header>
<rt-dialog-body [formGroup]="form" layout-horizontal>
  <rt-form-field>
    <rt-label>{{ 'app.requisitions.create_dialog.title_label' | translate }}</rt-label>
    <rt-input formControlName="title" />
  </rt-form-field>
  <rt-form-field>
    <rt-label>
      {{ texts.label }}
      @if (withDepartments) {
        <rt-icon-help
          [rtTooltip]="'app.requisitions.create_dialog.department_tooltip' | translate"
          margin-left-small-x
        />
      }
    </rt-label>
    <rt-select
      [placeholder]="texts.placeholder"
      [hasInputTrigger]="true"
      [searchPlaceholder]="texts.searchPlaceholder"
      [options]="selectOptions"
      [includeEmptyOption]="withDepartments"
      formControlName="attributeId"
    />
  </rt-form-field>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="isStep">
  @if (isStep) {
    <rt-button class="optional" (click)="goBack()" variant="plain">
      <rt-icon name="arrow-back" />
      {{ 'app.common.go_back' | translate }}
    </rt-button>
  }
  <rt-button [disabled]="saving" (click)="cancel()" variant="plain">{{
    'app.common.cancel' | translate
  }}</rt-button>
  <rt-button
    [disabled]="form.invalid || saving"
    [loading]="saving"
    (click)="save()"
    variant="primary"
    >{{ 'app.common.save' | translate }}</rt-button
  >
</rt-dialog-footer>
